import { useState } from "react";
import { useNavigate } from "react-router-dom";
import userClient from '../../infrastructure/userClient';
import User from '../../domain/User';
import LoadingPopup from '../loading/LoadingPopup';
import { useMutation } from "@tanstack/react-query";
import {useLoggedUserContext} from "../../AppContext";
import ErrorPopup from "../error/ErrorPopup";
import UIError from "../UIError";
import './RegisterForm.css';

export default function RegisterForm() {
    const navigate = useNavigate();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');

    const setLoggedUser = useLoggedUserContext()[1];
    const registerUserQuery = useMutation({mutationFn: async () => await registerUser(login, password)});
    
    if (registerUserQuery.isSuccess) {
        const user = registerUserQuery.data;

        if (user) {
            setTimeout(() => {
                setLoggedUser(user);
                navigate('/');
            });
        }
    }

    const handleSubmit = (event) => {
        if (checkLogin(login) && checkPassword(password)) {
            event.preventDefault();
            registerUserQuery.mutate();
        }
    }

    return <>
        {registerUserQuery.isError && renderError(registerUserQuery.error)}
        {(registerUserQuery.isPending || registerUserQuery.isSuccess) ? <LoadingPopup/> : null} 
        <form onSubmit={e => handleSubmit(e)}>
            <div>
                <label>Login:
                    <input className={getInputClass(login, checkLogin)} type="text" required value={login} autoFocus="true" onChange={e => setLogin(e.target.value)}/>
                </label>
            </div>
            <div>
                <label>Password:
                    <input className={getInputClass(password, checkPassword)} type="password" required value={password} onChange={e => setPassword(e.target.value)}/>
                </label>
            </div>
            <div>
                <button disabled={!checkLogin(login) || !checkPassword(password)}>Register</button>
            </div>
        </form>
    </>
}

function getInputClass(value, check) {
    if (value.length === 0) {
        return "empty";
    }

    if (check(value)) {
        return "correct";
    }
    else {
        return "error";
    }
};

function checkLogin(value) {
    if (value.length < 3) {
        return false;
    }

    if (value.length > 32) {
        return false;
    }

    return value.match(/^[\p{Letter}\p{Mark}0-9 ]+$/gu) && value.trim().replaceAll(/ +/g, " ") === value;
}

function checkPassword(value) {
    if (value.length < 6) {
        return false;
    }

    if (value.length > 128) {
        return false;
    }

    return true;
}

function renderError(error) {
    if (error.name === "UIError" && error.message === "LOGIN_DUPLICATION") {
        return <div className="errorField">Login {error.details.login} is already used</div>
    }

    return <ErrorPopup message={error.message}/>
}

async function registerUser(login, password) {
    const res = await userClient.register(login, password);

    if (res.ok) {
        const json = await res.json();
        return new User(json);
    }

    if (res.status === 409) {
        throw new UIError("LOGIN_DUPLICATION", {login: login});
    }

    throw new UIError("Error status code: " + res.status);
};